import { env } from '../env';
import {
  CheckwareModel,
  RespondentRoleAssessmentPlan,
  RespondGroupModel,
  TreatmentModel,
} from '../types/models';

const baseUrl = env.REACT_APP_BASE_URL || '';

export const getAllCheckwareRespondentGroup = async (): Promise<
  RespondGroupModel[]
> => {
  const response = await fetch(`${baseUrl}/api/checkware/respondentgroup/all`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) throw new Error(await response.text());

  return await response.json();
};

export const getAllCheckwareRespondentRole =
  async (): Promise<CheckwareModel> => {
    const response = await fetch(
      `${baseUrl}/api/checkware/respondentrole/all`,
      {
        credentials: 'include',
        headers: { Accept: 'application/json' },
      }
    );

    if (!response.ok) throw new Error(await response.text());

    return await response.json();
  };

export const getAllCheckwareTreatmentType = async (): Promise<
  TreatmentModel[]
> => {
  const response = await fetch(`${baseUrl}/api/checkware/treatmenttype/all`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) throw new Error(await response.text());

  return await response.json();
};

export const getAllCheckwareAssessmentplan = async (
  id: string
): Promise<RespondentRoleAssessmentPlan[]> => {
  const response = await fetch(
    `${baseUrl}/api/checkware/assessmentplan/${id}`,
    {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    }
  );

  if (!response.ok) throw new Error(await response.text());

  return await response.json();
};
